<div class="select-car-content">
  <h3 class="section-title">{{ sectionTitle }}</h3>
  <div class="white-pane">
    <div class="scrollable-content">

      <!-- Loading -->
      <div *ngIf="isLoadingPackages" class="loading-packages">
        <div class="loading-spinner"></div>
        <p>Loading car wash packages...</p>
      </div>

      <!-- Package cards (reuses existing PackageCardComponent) -->
      <app-package-card
        *ngFor="let tier of washTiers; trackBy: trackByTier"
        [title]="tier.name"
        [features]="tier.features"
        [options]="tier.options"
        [selectedOptionId]="selectedTierId === tier.id ? selectedOptionId : ''"
        (selectionChange)="onPackageSelected(tier.id, $event)">
      </app-package-card>

      <!-- Empty state -->
      <app-no-packages
        *ngIf="!isLoadingPackages && washTiers.length === 0"
        (addPackage)="onAddPackage()">
      </app-no-packages>

    </div>

    <!-- Actions -->
    <div class="select-car-actions">
      <button class="cancel" (click)="cancel.emit()">Cancel</button>
      <div class="footer-right">
        <button
          class="continue"
          [disabled]="!selectedOptionId || isLoadingPackages"
          (click)="onContinue()">
          Continue
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Package Modal (triggered when no packages exist) -->
<app-add-package-modal
  *ngIf="showAddPackageModal"
  (close)="onAddPackageModalClose()">
</app-add-package-modal>
